export const APP_NAME_POSTFIX = 'Driven by MyRidingLife';